// src/hooks/useAuth.js
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../store/slices/authSlice';
import { useLogoutMutation } from '../store/api/authApi';
import { ROUTES } from '../utils/constants';

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const [logoutMutation] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutMutation().unwrap();
    } catch (error) {
      // Even if the API call fails, we still want to clear local state
      console.error('Logout API call failed:', error);
    } finally {
      dispatch(logout());
      navigate(ROUTES.LOGIN);
    }
  };

  const hasRole = (requiredRole) => {
    return auth.role === requiredRole;
  };

  const hasAnyRole = (roles) => {
    return roles.includes(auth.role);
  };

  return {
    ...auth,
    logout: handleLogout,
    hasRole,
    hasAnyRole,
  };
};